"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberButton = exports.NumberButtonContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const style_1 = __importDefault(require("style"));
const NumberContainer_1 = require("./NumberContainer");
const Subheader_1 = require("../Subheader");
const SIZE = style_1.default.Sizing.Size.Base;
exports.NumberButtonContainer = (0, styled_components_1.default)(NumberContainer_1.NumberContainer) `
  height: ${SIZE};
  width: ${SIZE};
`;
const NumberButton = (props) => {
    const { value, onClick, isSelected = false, isDisabled = false } = props;
    const wrappedOnClick = react_1.default.useCallback(() => {
        if (!isDisabled) {
            onClick();
        }
    }, [isDisabled, onClick]);
    return ((0, jsx_runtime_1.jsx)(exports.NumberButtonContainer, Object.assign({ isDisabled: isDisabled, isSelected: isSelected, onClick: wrappedOnClick }, { children: (0, jsx_runtime_1.jsx)(Subheader_1.Subheader, { children: value }) })));
};
exports.NumberButton = NumberButton;
